<template>
	    <el-card class="box-card">
        <!-- 标题&时间 -->
        <el-row :gutter="40" class='select_row'>
            <el-col :span="7">
                <el-row>
                    <el-col :span='8' class="select_span">
                        <span>选择科室:</span>
                    </el-col>
                    <el-col :span='16'>
		  				<el-select v-model="departmentsSelect" placeholder="请选择"
		  				 size='small' style="max-width: 130px;"> 
						    <el-option
						      v-for="item in select.departmentsSelect"
						      :key="item.id"
						      :label="item.name"
						      :value="item.id">
						    </el-option>
					  	</el-select>
                    </el-col>
                </el-row>
            </el-col>
            <el-col :span="7">
                <el-row>
                    <el-col :span='16' class='floatR'>
                        <el-date-picker size='small'
                          v-model="timeRange"
                          type="datetimerange"
                          range-separator="至"
                          start-placeholder="开始日期"
                          end-placeholder="结束日期"
                          :picker-options="pickerOptions"
                          value-format="yyyy-MM-dd HH:mm:ss">
                        </el-date-picker>
                    </el-col>
                    <el-col :span='8' class="select_span">
                        <span>选择时间:</span>
                    </el-col>
                </el-row>
            </el-col>
        </el-row>
        <!-- 选择职称&注册来源 -->        
        <el-row :gutter="40" class='select_row'>
            <el-col :span="7">
                <el-row>
                    <el-col :span='8' class="select_span">
                        <span>选择职称:</span>
                    </el-col>
                    <el-col :span='16'>
		  				<el-select v-model="jobTitleSelect" placeholder="请选择"
		  				 size='small' style="max-width: 130px;"> 
						    <el-option
						      v-for="item in select.jobTitleSelect"
						      :key="item.id"
						      :label="item.name"
						      :value="item.id">
						    </el-option>
					  	</el-select>
                    </el-col>
                </el-row>
            </el-col>
            <el-col :span="7">
                <el-row v-if='!isPay'>
                    <el-col :span='8' class="select_span">
                        <span>注册来源:</span>
                    </el-col>
                    <el-col :span='16'>
		  				<el-select v-model="sourceSelect" placeholder="请选择"
		  				 size='small' style="max-width: 130px;"> 
						    <el-option
						      v-for="item in select.sourceSelect"
						      :key="item.id"
						      :label="item.name"
						      :value="item.id">
						    </el-option>
					  	</el-select>
                    </el-col>
                </el-row>
                <el-row v-else>
                    <el-col :span='8' class="select_span">
                        <span>付费类型:</span>
                    </el-col>
                    <el-col :span='16'>
		  				<el-select v-model="payType" placeholder="请选择"
		  				 size='small' style="max-width: 130px;"> 
						    <el-option
						      v-for="item in select.payTypeList"
						      :key="item.id"
						      :label="item.name"
						      :value="item.id">
						    </el-option>
					  	</el-select>
                    </el-col>
                </el-row>
            </el-col>
        </el-row>
		<!-- 认证状态 -->
		<el-row :gutter='40' class='select_row'
			v-if='select.checkList'>
			<el-col :span="14">
		  		<el-row>
		  			<el-col :span='4' class="select_span">
		  				<span>认证状态:</span>
		  			</el-col>
		  			<el-col :span='14'>
		  				<el-checkbox-group v-model="checkList" class='check_group'>
						    <el-checkbox v-for='item in select.checkList'
						     :label='item.id' :key='item.id'>{{item.name}}</el-checkbox>
					  	</el-checkbox-group>
		  			</el-col>
		  		</el-row>
			</el-col>
		</el-row>
        <!-- 筛选重置 -->
        <el-row :gutter='40' class='select_row' style='margin-bottom: 0;'>
            <el-col :span='7'>
                <el-row>
                    <el-col :span='8' class="select_span">&nbsp;
                    </el-col>
                    <el-col :span='16'>
                        <el-button type="warning" plain size="small"
                         @click='reset'>重置</el-button>
                        <el-button type="primary" plain size="small"
                         @click='screen'>筛选</el-button>
                    </el-col>
                </el-row>
            </el-col>
        </el-row>
    </el-card>
</template>
<script scoped>
	import commonApi from '@/api/common'
	export default{
		name: 'docAmountSreen',
		data() {
			return {
				// 日期
	            timeOptionRange: null,
				pickerOptions: {
                    disabledDate: (time) => {
	                    // 获取选中时间
	                    let timeOptionRange = this.timeOptionRange;
	                    // 获取时间范围(30天的毫秒数)
	                    let secondNum = 31 * 24 * 60 * 60 * 1000;
	                    if (timeOptionRange) {
	                        //如果有选中时间 设置超过选中时间后的30天||超过选中前的30天||大于当前时间 不可选
	                        return time.getTime() > timeOptionRange.getTime() + secondNum || time.getTime() < timeOptionRange.getTime() - secondNum || time.getTime() > (Date.now() - 8.64e6);
	                    } else {
	                        //如果没有选中时间（初始化状态） 设置当前时间后的时间不可选
	                        return time.getTime() > (Date.now() - 8.64e6);
	                    }
	                },
	                onPick: (maxDate, minDate) => {
	                    // 当选中了第一个日期还没选第二个
	                    // 只选中一个的时候自动赋值给minDate，当选中第二个后组件自动匹配，将大小日期分别赋值给maxDate、minDate
	                    if (maxDate.minDate && !maxDate.maxDate) {
	                        this.timeOptionRange = maxDate.minDate;
	                    }
	                    // 如果有maxDate属性，表示2个日期都选择了，则重置timeOptionRange
	                    if (maxDate.maxDate) {
	                        this.timeOptionRange = null;
	                    }
	                }
                },
				timeRange: [],
				payType: 0,
				checkList: [1,2,3],
				departmentsSelect: '',
				jobTitleSelect: '',
				sourceSelect: '',
				select: {
	                checkList: [{
	                    id: 1, name: '未认证'},{
	                    id: 2, name: '普通认证'},{
	                    id: 3, name: '权威认证'}
	                ],
	                payTypeList: [{
	                	id: 0, name: '全部'},{
	                	id: 3, name: '课程购买'},{
	                	id: 5, name: 'VIP购买'},{
	                	id: 4, name: '学习币购买'
	                }]
                }
			}
		},
		props: {
			defaultTime: Array,
			isPickerOptionsSelf: {
				type: Boolean,
				default: false
			},
			pickerOptionsSelf: Object,
			isPay: {
				type: Boolean,
				default: false
			}
		},
		watch: {
	    },
		mounted() {
			if(this.pickerOptionsSelf){
				this.pickerOptions = this.pickerOptionsSelf
			}
	        // 默认时间不为空
	        if(this.defaultTime&&this.defaultTime.length!=0){
	            this.defaultTime[0] = this.$moment(this.defaultTime[0])
	              .format('YYYY-MM-DD HH:mm:ss')
	            this.defaultTime[1] = this.$moment(this.defaultTime[1])
	              .format('YYYY-MM-DD HH:mm:ss')
	        }
	        this.timeRange = this.defaultTime ? this.defaultTime : []

			this.getSelectList()
		},
		methods: {			
			// 筛选项静态内容获取
			getSelectList() {
				commonApi.getSelect().then((res) => {
					console.log(res,'res');
					if(res.Success){
						this.select.auditingTypeSelect === -1
						?res.Data.auditingTypeSelect = -1
						:res.Data.auditingTypeSelect.unshift({id:'',name:'全部审核方式'})
						res.Data.departmentsSelect.unshift({id:'',name:'全部科室'})
						res.Data.jobTitleSelect.unshift({id:'',name:'全部职称'})
						res.Data.sourceSelect.unshift({id:'',name:'全部来源'})
						this.select = {...this.select,...res.Data}
					}else{
						this.$message.error(res.Msg)
					}
				})
			},
			getData() {
				let data = {
					department: this.departmentsSelect || null,
					title: this.jobTitleSelect || null,
					source: this.sourceSelect || null,
					payType: this.payType || null,
					timeRange: this.timeRange,
					checkList: this.checkList
				}
				return data
			},
			screen() {
				let data = this.getData()
				this.$emit('screen',data)
			},
			reset() {
		        // 默认时间不为空
		        if(this.defaultTime&&this.defaultTime.length!=0){
		            this.defaultTime[0] = this.$moment(this.defaultTime[0])
		              .format('YYYY-MM-DD HH:mm:ss')
		            this.defaultTime[1] = this.$moment(this.defaultTime[1])
		              .format('YYYY-MM-DD HH:mm:ss')
		        }
		        this.timeRange = this.defaultTime ? this.defaultTime : []

				this.checkList = [0,1,2]
				this.departmentsSelect = ''
				this.jobTitleSelect = ''
				this.sourceSelect = ''

			}
		}
	};
</script>
<style type="text/less" lang="less" scoped>
	.header{
        margin-bottom: 15px;
    }
    .box-card{
        padding: 15px 0;
    }
    .select_span{
        text-align: right;
        padding-right: 15px;
        span{
            font-size: 14px;
        }
    }
    .select_row{
        margin-bottom: 20px;
    }
    .select_row>.el-col{
        padding-left: 0!important;
        padding-right: 0!important;
        margin-left: 20px;
        margin-right: 20px;
    }
    .check_group{
        display: inline-block;
    }
    .table_list{
        margin: 20px 0;
    }
    .pagination{
        float: right;
    }
    .click_word{
        color: #409EFF;
        cursor: pointer;
        text-decoration: underline;
    }
</style>


// WEBPACK FOOTER //
// src/views/databaseAnlysis/components/docAmountScreen.vue